import { cn } from '~/utils';

function mergeWithClassNamesCustomizer(objValue: any, srcValue: any) {
  if (typeof objValue === 'string' && typeof srcValue === 'string') {
    return cn(objValue, srcValue);
  }
}

export default mergeWithClassNamesCustomizer;
